module.exports = __webpack_public_path__ + "static/media/close.2145f352.svg";


//////////////////
// WEBPACK FOOTER
// ./src/view/popup/close.svg
// module id = 1002
// module chunks = 0